import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { unstable_batchedUpdates } from "react-dom";
import { withNamespaces } from "react-i18next";
import { AvForm } from "availity-reactstrap-validation";
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Button,
  CardTitle,
  Modal,
  ModalHeader,
  ModalBody,
  Spinner,
} from "reactstrap";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import Breadcrumb from "../../../../components/Common/Breadcrumb";
import moment from "moment";
import filterFactory, { selectFilter } from "react-bootstrap-table2-filter";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import exportFromJSON from "export-from-json";
import showNotification from "../../../../helpers/show_notification";
import { postSubmitForm } from "../../../../helpers/forms_helper";
// import * as XLSX from 'xlsx';
import { exportFromula, formatUnitsForReport, mapUnits } from "../../../../helpers/units";
import printDiv from "../../../../helpers/print_data";

const monthColors = [
  { light: '#e6f3ff', header: '#2196f3' },  // Blue
  { light: '#ffe6e6', header: '#f44336' },  // Red
  { light: '#e6ffe6', header: '#4caf50' },  // Green
  { light: '#fff2e6', header: '#ff9800' },  // Orange
  { light: '#f3e6ff', header: '#9c27b0' },  // Purple
  { light: '#e6ffff', header: '#00bcd4' },  // Cyan
  { light: '#fff9e6', header: '#ffc107' },  // Amber
  { light: '#ffe6f3', header: '#e91e63' },  // Pink
  { light: '#e6ffe9', header: '#8bc34a' },  // Light Green
  { light: '#e6ecff', header: '#3f51b5' },  // Indigo
  { light: '#ffe6ee', header: '#ff5252' },  // Red Accent
  { light: '#e6fff9', header: '#009688' },  // Teal
];

const FoodConsumptionReport = (props) => {
  const { SearchBar } = Search;
  const [monthYear, setMonthYear] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingDetails, setIsLoadingDetails] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [monthData, setMonthData] = useState();
  const [MonthlyTotalCost, setMonthlyTotalCost] = useState(0);
  const [currentMonthYear, setCurrentMonthYear] = useState();
  const [tablePage, setTablePage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const reportRequestId = useRef(0);
  const detailsRequestId = useRef(0);

    useEffect(() => {
      setMonthYear(moment().format('YYYY-MM'));
      setCurrentMonthYear(moment().format('YYYY-MM'));
    }, []);
function afterFilter(newResult, newFilters) {
  let total = 0;
  if(newResult?.length>0){
   total = newResult?.reduce((a, c) => a + Number(c.receiving_price || 0), 0);
  }
  setMonthlyTotalCost(total)
}

     const [allData, setAllData] = useState([]);
  const loadAllData = async () => {
    const requestId = ++reportRequestId.current;
    try {
        if (!monthYear) {
      setAllData({ items: [], months: [] });
      showNotification("Please select month", "Error");
      return false;
    }
    unstable_batchedUpdates(() => {
      setIsLoading(true);
      setAllData({ items: [], months: [] });
      setTablePage(1);
    });
    let url = process.env.REACT_APP_BASEURL + "reports/monthly_consumption_report";
    const response = await postSubmitForm(url, {upToMonth:monthYear});
    if (requestId !== reportRequestId.current) return false;
    if (response && response.status === 1) {
      const payload = response.data || {};
      const items = (payload.items || []).map((row) => {
        const formula = row.formula || (row.unit_levels ? exportFromula(row.unit_levels) : "");
        return {
          ...row,
          unit_levels: undefined,
          _id: row._id || `${row.item_id}_${row.supplier_id}`,
          formula,
        };
      });
      unstable_batchedUpdates(() => {
        setAllData({ ...payload, items });
        setTablePage(1);
        setIsLoading(false);
      });
    } else {
      showNotification(response && response.message, "Error");
      setIsLoading(false);
    }
    } catch (error) {
     if (requestId !== reportRequestId.current) return false;
     console.log(error);
     setIsLoading(false);
    }
  };

  const loadMonthlyData = useCallback(async (month,row) => {
    const requestId = ++detailsRequestId.current;
    try {
      const formatted = moment(month?.label, "MMM YYYY").format("YYYY-MM");
    setMonthData({ deliveries: [], month_label: month?.label, item_info: { item_name: row?.name, supplier_name: row?.supplier } });
    setMonthlyTotalCost(0);
    setIsModalOpen(true);
    setIsLoadingDetails(true);
    let payload = {
      month:formatted,
      itemId:row?.item_id,
      supplierId:row?.supplier_id
    }
    let url = process.env.REACT_APP_BASEURL + "reports/monthly_consumption_details";
    const response = await postSubmitForm(url, payload);
    
    if (requestId !== detailsRequestId.current) return;
    if (response && response.status === 1) {
      setMonthData(response?.data);
      let total = response.data?.deliveries?.reduce((a, c) => a + Number(c.receiving_price || 0), 0);
      setMonthlyTotalCost(total)
    } else {
      showNotification(response && response.message, "Error");
    }
    } catch (error) {
     if (requestId !== detailsRequestId.current) return;
     console.log(error);
    } finally {
      if (requestId === detailsRequestId.current) {
        setIsLoadingDetails(false);
      }
    }
  }, []);

const columns = useMemo(() => {
  const months = Array.isArray(allData?.months) ? allData.months : [];
  const baseColumns = [
  {
    dataField: "sn",
    text: "S.N",
    headerStyle: { width: "50px" },
    sort: true,
  },
  {
    dataField: "name",
    text: "Item",
    formatter: (cell, row) => {
        return (
          <div 
            title={row.formula ? `Formula: ${row.formula}` : ""}
            className="items_name"
            style={{ 
              cursor: 'pointer',
            }}
          >
            {row.name}
          </div>
        );
      },
    headerStyle: { width: "150px" },
    sort: true,
  },
  {
    dataField: "supplier",
    text: "Supplier Name",
    headerStyle: { width: "150px" },
    sort: true,
  },
  {
    dataField: "unit",
    text: "Purchasing Unit",
    headerStyle: { width: "100px" },
    sort: true,
  },
  ];
  const monthColumns = months.flatMap((m, monthIndex) => {
  const colorIndex = monthIndex % monthColors.length;  
  return [
    {
      dataField: `${m.key}_latest_price`,
      text: (
        <div style={{ textAlign: "center", position: "relative" }}>
          {/* Month name spanning across columns */}
          <div style={{
            position: "absolute",
            top: "-25px",
            left: "0",
            right: "-160px",
            height: "20px",
            backgroundColor: monthColors[colorIndex].header,
            color: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: "bold",
            fontSize: "12px",
            borderBottom: "1px solid #fff",
            zIndex: 10
          }}>
            {m.label}
          </div>
          <div style={{ fontSize: "10px", marginTop: "5px" }}>Latest Price</div>
        </div>
      ),
      headerStyle: { 
        textAlign: "center",
        fontSize: "11px", 
        width: "80px",
        backgroundColor: monthColors[colorIndex].header,
        color: "white",
        padding: "20px 0px 8px 0px",
        position: "relative"
      },
        style: (cell, row, rowIndex, columnIndex) => {
        const currentMonth = m.key;
        const currentPrice = Number(row[`${currentMonth}_latest_price`]);

        const isValid = (val) => typeof val === 'number' && !isNaN(val) && val !== 0;

        const prevMonth = monthIndex > 0 ? months[monthIndex - 1].key : null;
        const nextMonth = monthIndex < months.length - 1 ? months[monthIndex + 1].key : null;

        const prevPrice = prevMonth ? Number(row[`${prevMonth}_latest_price`]) : null;
        const nextPrice = nextMonth ? Number(row[`${nextMonth}_latest_price`]) : null;

        let isDifferent = false;

        // Skip highlighting for index 0
        if (monthIndex > 0 && isValid(currentPrice)) {
          const prevDiff = isValid(prevPrice) && currentPrice !== prevPrice;
          const nextDiff = isValid(nextPrice) && currentPrice !== nextPrice;

          // Highlight if either adjacent price is different
          if (prevDiff) {
            isDifferent = true;
          }
        }

        return {
          backgroundColor: isDifferent ? "#ffdddd" : monthColors[colorIndex].light,
          color: isDifferent ? "#d40000" : "black",
          textAlign: "right",
          fontWeight: isDifferent ? "bold" : "normal",
        };
      },

      // style: (cell, row, rowIndex) => ({
      //   backgroundColor: monthColors[colorIndex].light,
      //   textAlign: "right"
      // }),
      formatter: (cell) => cell ? `${Number(cell.toFixed(2))}` : 0,
      sort: true,
    },
    {
      dataField: `${m.key}_qty`,
      text: (
        <div style={{ textAlign: "center" }}>
          <div style={{ fontSize: "10px", marginTop: "5px" }}>QTY</div>
        </div>
      ),
      headerStyle: { 
        textAlign: "center",
        fontSize: "11px", 
        width: "80px",
        backgroundColor: monthColors[colorIndex].header,
        color: "white",
        padding: "20px 4px 8px 4px"
      },
      style: (cell, row, rowIndex) => ({
        backgroundColor: monthColors[colorIndex].light,
        textAlign: "right"
      }),
       formatter: (cell, row, rowIndex) => {
        const value = typeof cell === 'number' ? Number(cell.toFixed(2)) : 0;
        return (
          <span
            style={{ cursor: 'pointer', color: 'blue' }}
            onClick={() => {
               loadMonthlyData(m,row)
            }}
          >
            {value}
          </span>
        );
      },
      sort: true,
    },
    {
      dataField: `${m.key}_cost`,
      text: (
        <div style={{ textAlign: "center" }}>
          <div style={{ fontSize: "10px", marginTop: "5px" }}>COST</div>
        </div>
      ),
      headerStyle: { 
        textAlign: "center",
        fontSize: "11px", 
        width: "80px",
        backgroundColor: monthColors[colorIndex].header,
        color: "white",
        padding: "20px 4px 8px 4px"
      },
      style: (cell, row, rowIndex) => ({
        backgroundColor: monthColors[colorIndex].light,
        textAlign: "right"
      }),
      formatter: (cell) => cell ? `${Number(cell.toFixed(2))}` : 0,
      sort: true,
    },
  ];
  });
  return baseColumns.concat(monthColumns);
}, [allData.months, loadMonthlyData]);

const columnsPurchaseDetails =  [
    // {
    //   dataField: "item_id",
    //   hidden: true,
    // },
    // {
    //   dataField: "seq_no",
    //   text: props.t("S.N"),
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "5%" };
    //   },
    // },
   {
    dataField: "po_id",
    text: "PO ID",
     formatter: (cell, row) => {
        return (
          <div>
            <div>{cell}</div>
            {row.po_id  && (
              <small>
                <a
                  href={"/purchase_order?po_id=" + row.po_id}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-info"
                >
                  PO: {row.po_id}
                </a>
              </small>
            )}
          </div>
        );
      },
     headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    sort: true,
  },
    //   {
    //   dataField: "unit_levels",
    //   text: props.t("Formula"),
    //   sort: true,
    //   formatter: (cell, row) => {
    //     return mapUnits(row?.unit_levels);
    //   },
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "11%" };
    //   },
    // },
  // {
  //   dataField: "supplier_name",
  //   text: "Supplier Name",
  //   headerStyle: { width: "150px" },
  //   sort: true,
  // },
  {
    dataField: "branch_name",
    text: "Store/Branch Name",
headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      sort: true,
  },
   {
      dataField: "is_free",
      text: props.t("Free ?"),
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      formatter: (cell) => (cell ? "Yes" : "No"),
      filter: selectFilter({
        options: [
          { value: true, label: "Yes" },
          { value: false, label: "No" },
        ],
        placeholder: "All",
         style: {
          height: "30px",
          marginLeft: "5px",
          padding:"0px"
        }
      }),
    },
//   {
//     dataField: "unit_price_for",
//     text: "Purchasing Unit",
// headerStyle: (colum, colIndex) => {
//         return { width: "8%" };
//       },
//       sort: true,
//   },
   {
    dataField: "unit_price",
    text: "Cost Price",
     formatter: (cell, row) => {
        return row.unit_price + "/" + row.unit_price_for;
      },
    sort: true,
    headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
  },

    {
      dataField: "unit_price_for",
      text: props.t("Received"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.received_quantity);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "receiving_price",
      text: props.t("Total Cost (QR)"),
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return Number(row.receiving_price?.toFixed(2));
      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
  ];
/* Rotate month headers for space efficiency */
        // table th span {
        //   writing-mode: vertical-rl;
        //   text-orientation: mixed;
        //   transform: rotate(180deg);
        //   white-space: nowrap;
        //   font-size: 5px !important;
        // }
function printDivForMainTable(divName) {
  let printContents = document.getElementById(divName);
  let searchelement = printContents.getElementsByClassName("sr-only");
  if (searchelement && searchelement[0]?.parentNode) {
    searchelement[0].parentNode.removeChild(searchelement[0]);
  }
  
  // dynamic column widths based on number of months
  const monthCount = allData?.months?.length || 0;
  const baseColumns = 4; // S.N, Item, Supplier, Unit
  const monthColumns = monthCount * 3; // Latest Price, QTY, Cost per month
  const totalColumns = baseColumns + monthColumns;
  
  //  widths for A3 Portrait
  const availableWidth = 100; // percentage
  const snWidth = Math.max(3, 100 / totalColumns);
  const itemWidth = Math.max(12, (100 * 3) / totalColumns);
  const supplierWidth = Math.max(10, (100 * 2.5) / totalColumns);
  const unitWidth = Math.max(6, (100 * 1.5) / totalColumns);
  const monthColWidth = Math.max(4, (100 * 0.8) / totalColumns);
  
  var winPrint = window.open(
    "",
    "",
    "left=0,top=0,toolbar=0,scrollbars=1,status=0"
  );
  winPrint.document.write(
    `<title>${divName} Report</title>
    <head>
      <style>
        @page { 
          size: A3 Portrait;
          margin: 3mm;
        }
        body {
          margin: 0;
          padding: 2mm;
          font-size: 6px !important;
          font-family: Arial, sans-serif;
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
        }
        #${divName}, #${divName} * { 
          visibility: visible; 
        }
        #${divName} {
          position: relative;
          width: 100%;
          font-size: 6px !important;
        }
        table { 
          width: 100% !important;
          table-layout: fixed;
          border-collapse: collapse;
          font-family: Arial, sans-serif;
          margin: 0 !important;
          font-size: 6px !important;
        }
        table th {
          padding: 2px !important;
          border: 0.3px solid #333;
          font-weight: bold;
          text-align: center;
          font-size: 8px !important;
          word-wrap: break-word;
          word-break: break-word;
          overflow-wrap: break-word;
          white-space: normal;
          line-height: 1.2;
          vertical-align: top;
          height: auto;
        }
        table td {
          padding: 2px !important;
          border: 0.3px solid #333;
          font-size: 7px !important;
          word-wrap: break-word;
          word-break: break-word;
          overflow-wrap: break-word;
          white-space: normal;
          line-height: 1.3;
          vertical-align: top;
          height: auto;
        }
        
        /* Dynamic column widths based on total columns */
        table th:nth-child(1), table td:nth-child(1) { 
          width: ${snWidth}% !important; 
          min-width: 20px;
          text-align: center;
        }
        table th:nth-child(2), table td:nth-child(2) { 
          width: ${itemWidth}% !important; 
          min-width: 60px;
          text-align: left;
        }
        table th:nth-child(3), table td:nth-child(3) { 
          width: ${supplierWidth}% !important; 
          min-width: 50px;
          text-align: left;
        }
        table th:nth-child(4), table td:nth-child(4) { 
          width: ${unitWidth}% !important; 
          min-width: 30px;
          text-align: center;
        }
        
        /* Month columns - Latest Price, QTY, Cost pattern */
        ${Array.from({length: monthCount}, (_, i) => {
          const startCol = 5 + (i * 3);
          return `
            table th:nth-child(${startCol}), table td:nth-child(${startCol}) { 
              width: ${monthColWidth}% !important; 
              min-width: 25px;
              text-align: right;
             
            }
            table th:nth-child(${startCol + 1}), table td:nth-child(${startCol + 1}) { 
              width: ${monthColWidth}% !important; 
              min-width: 25px;
              text-align: right;
          
            }
            table th:nth-child(${startCol + 2}), table td:nth-child(${startCol + 2}) { 
              width: ${monthColWidth}% !important; 
              min-width: 25px;
              text-align: right;
           
            }
          `;
        }).join('')}
        
        /* Specific styling for numeric columns to handle overflow */
        table td:nth-child(n+5) {
          font-size: 7px !important;
          padding: 1px !important;
          max-width: 0;
          overflow: visible;
          white-space: normal;
          word-break: break-all;
          hyphens: auto;
        }
        
        /* Long numbers handling */
        .numeric-cell {
          display: block;
          width: 100%;
          font-size: 7px !important;
          line-height: 1.1;
          text-align: right;
          word-break: break-all;
        }
        
        table tr:nth-child(even) {
          background-color: #f5f5f5 !important;
        }
        
        /* Adjust row height to accommodate wrapped text */
        table tr {
          height: auto !important;
          min-height: 12px;
        }
        
        /* Hide unnecessary elements */
        .btn, 
        .search-bar, 
        .no-print,
        .react-bootstrap-table-pagination,
        .react-bootstrap-table-filter-wrapper,
        .search-label,
        .react-bootstrap-table-search,
        .card-title,
        .breadcrumb {
          display: none !important;
        }
        
        /* Ensure content fits page */
        .table-responsive {
          overflow: visible !important;
          min-width: auto !important;
          width: 100% !important;
        }
        .react-bootstrap-table {
          margin: 0 !important;
          padding: 0 !important;
          width: 100% !important;
        }
        
        /* Special handling for very long numbers */
        @media print {
          table td {
            page-break-inside: avoid;
          }
          
          /* Force break long numbers with commas or periods */
          table td:nth-child(n+5)::after {
            content: "";
            white-space: pre;
          }
        }
        
        /* Compact numeric values with better wrapping */
        .numeric {
         
          text-align: right;
          font-size: 7px !important;
          line-height: 1.1;
          word-spacing: -1px;
        }
      </style>
    </head>
    <body>
      ${printContents.innerHTML}
    </body>
    `
  );
  winPrint.document.close();
  winPrint.focus();
  setTimeout(() => {
    winPrint.print();
    // winPrint.close();
  }, 500);
}


// const handleDownload = () => {
//   const fileName = `food_consumption_report_${monthYear}`;
//   const exportType = "xls";
//  const allMonths = allData.months || [];
//   const exportData = allData.items?.map((row, idx) => {
//     let rowObj = {
//       "#": idx + 1,
//       "Item Name": row.name,
//       "Supplier": row.supplier,
//       "Unit": row.unit,
//     };
    
//     allMonths.forEach(m => {
//       rowObj[`${m.label} Latest Price`] = row[`${m.key}_latest_price`] || "";
//       rowObj[`${m.label} QTY`] = row[`${m.key}_qty`] || "";
//       rowObj[`${m.label} Cost`] = row[`${m.key}_cost`] || "";
//     });
    
//     return rowObj;
//   });

//   exportFromJSON({ data: exportData, fileName, exportType });
// };


const handleDownload1 = () => {
  const fileName = `food_consumption_report_${monthYear}`;
  const exportType = "xls";
  const allMonths = allData.months || [];
  
  // Create structured export data with better column organization
  const exportData = [];
  
  // Add a title row
  exportData.push({
    "#": "Supplier Food Consumption Report",
    "Item Name": `Period: ${monthYear}`,
    "Supplier": "",
    "Unit": "",
    ...Object.fromEntries(
      allMonths.flatMap(m => [
        [`${m.label}_Price`, ""],
        [`${m.label}_Qty`, ""],
        [`${m.label}_Cost`, ""]
      ])
    )
  });
  
  // Add an empty row for spacing
  exportData.push({
    "#": "",
    "Item Name": "",
    "Supplier": "",
    "Unit": "",
    ...Object.fromEntries(
      allMonths.flatMap(m => [
        [`${m.label}_Price`, ""],
        [`${m.label}_Qty`, ""],
        [`${m.label}_Cost`, ""]
      ])
    )
  });
  
  // Add header row with clear month grouping
  exportData.push({
    "#": "S.N",
    "Item Name": "Item Name",
    "Supplier": "Supplier Name",
    "Unit": "Purchasing Unit",
    ...Object.fromEntries(
      allMonths.flatMap(m => [
        [`${m.label}_Price`, `${m.label} - Latest Price`],
        [`${m.label}_Qty`, `${m.label} - QTY`],
        [`${m.label}_Cost`, `${m.label} - COST`]
      ])
    )
  });
  
  // Add data rows
  allData.items.forEach((row, idx) => {
    const dataRow = {
      "#": idx + 1,
      "Item Name": row.name,
      "Supplier": row.supplier,
      "Unit": row.unit,
    };
    
    // Add month data with clear labeling
    allMonths.forEach(m => {
      dataRow[`${m.label}_Price`] = row[`${m.key}_latest_price`] || "";
      dataRow[`${m.label}_Qty`] = row[`${m.key}_qty`] || "";
      dataRow[`${m.label}_Cost`] = row[`${m.key}_cost`] || "";
    });
    
    exportData.push(dataRow);
  });

  exportFromJSON({ data: exportData, fileName, exportType });
};


// const handleDownload = () => {
//   const fileName = `food_consumption_report_${monthYear}`;
//   const allMonths = allData.months || [];
//   const wb = XLSX.utils.book_new();
//   const wsData = [];
  
//   // Row 1: Month headers (spans 3 columns each)
//   const monthHeaderRow = ['S.N', 'Item', 'Supplier Name', 'Purchasing Unit'];
//   allMonths.forEach(month => {
//     monthHeaderRow.push(month.label, '', ''); // Month name, then 2 empty cells for merging
//   });
//   wsData.push(monthHeaderRow);
  
//   // Row 2: Sub-headers
//   const subHeaderRow = ['', '', '', ''];
//   allMonths.forEach(() => {
//     subHeaderRow.push('Latest Price', 'QTY', 'COST');
//   });
//   wsData.push(subHeaderRow);
  
//   // Data rows
//   allData.items.forEach((row, idx) => {
//     const dataRow = [
//       row.sn, // S.N
//       row.name, // Item
//       row.supplier, // Supplier
//       row.unit // Unit
//     ];
    
//     // Add month data
//     allMonths.forEach(m => {
//       dataRow.push(
//         row[`${m.key}_latest_price`] || '',
//         row[`${m.key}_qty`] || '',
//         row[`${m.key}_cost`] || ''
//       );
//     });
    
//     wsData.push(dataRow);
//   });
  
//   // Create worksheet
//   const ws = XLSX.utils.aoa_to_sheet(wsData);
  
//   // Calculate range
//   const totalCols = 4 + (allMonths.length * 3);
//   const totalRows = wsData.length;
//   const range = XLSX.utils.encode_range(
//     { c: 0, r: 0 }, 
//     { c: totalCols - 1, r: totalRows - 1 }
//   );
//   ws['!ref'] = range;
  
//   // Set up merges for month headers
//   const merges = [];
//   allMonths.forEach((month, index) => {
//     const startCol = 4 + (index * 3);
//     const endCol = startCol + 2;
//     merges.push({
//       s: { r: 0, c: startCol }, // start: row 0, column startCol
//       e: { r: 0, c: endCol }     // end: row 0, column endCol
//     });
//   });
//   ws['!merges'] = merges;
  
//   // Apply styles to cells
//   for (let R = 0; R < totalRows; R++) {
//     for (let C = 0; C < totalCols; C++) {
//       const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
//       if (!ws[cellAddress]) continue;
      
//       // Initialize cell style
//       ws[cellAddress].s = {
//         border: {
//           top: { style: "thin", color: { rgb: "000000" } },
//           bottom: { style: "thin", color: { rgb: "000000" } },
//           left: { style: "thin", color: { rgb: "000000" } },
//           right: { style: "thin", color: { rgb: "000000" } }
//         }
//       };
      
//       // Style header rows (Row 0 and 1)
//       if (R === 0 || R === 1) {
//         // Base columns styling (dark)
//         if (C < 4) {
//           ws[cellAddress].s.fill = { fgColor: { rgb: "424242" } };
//           ws[cellAddress].s.font = { bold: true, color: { rgb: "FFFFFF" } };
//           ws[cellAddress].s.alignment = { horizontal: "center", vertical: "center" };
//         } else {
//           // Month columns styling
//           const monthIndex = Math.floor((C - 4) / 3);
//           const colorSet = monthColors[monthIndex % monthColors.length];
          
//           ws[cellAddress].s.fill = { fgColor: { rgb: colorSet.header } };
//           ws[cellAddress].s.font = { bold: true, color: { rgb: "FFFFFF" } };
//           ws[cellAddress].s.alignment = { horizontal: "center", vertical: "center" };
//         }
//       } else {
//         // Data rows styling
//         if (C < 4) {
//           // Base columns - white background
//           ws[cellAddress].s.fill = { fgColor: { rgb: "FFFFFF" } };
//           ws[cellAddress].s.alignment = { horizontal: C === 0 ? "center" : "left" };
//         } else {
//           // Month columns - light colored background
//           const monthIndex = Math.floor((C - 4) / 3);
//           const colorSet = monthColors[monthIndex % monthColors.length];
          
//           ws[cellAddress].s.fill = { fgColor: { rgb: colorSet.light } };
//           ws[cellAddress].s.alignment = { horizontal: "right" };
          
//           // Format numbers
//           if (typeof ws[cellAddress].v === 'number') {
//             ws[cellAddress].z = '#,##0.00';
//           }
//         }
//       }
//     }
//   }
  
//   // Set column widths
//   const colWidths = [
//     { wch: 6 },   // S.N
//     { wch: 25 },  // Item
//     { wch: 20 },  // Supplier
//     { wch: 12 },  // Unit
//   ];
  
//   // Add widths for month columns
//   for (let i = 0; i < allMonths.length; i++) {
//     colWidths.push(
//       { wch: 12 }, // Latest Price
//       { wch: 8 },  // QTY
//       { wch: 12 }  // COST
//     );
//   }
  
//   ws['!cols'] = colWidths;
  
//   // Set row heights for headers
//   ws['!rows'] = [
//     { hpt: 25 }, // First header row height
//     { hpt: 20 }  // Second header row height
//   ];
  
//   // Add worksheet to workbook
//   XLSX.utils.book_append_sheet(wb, ws, 'Food Consumption Report');
  
//   // Write file
//   XLSX.writeFile(wb, `${fileName}.xlsx`);
// };

// const handleDownloads = () => {
//   const fileName = `food_consumption_report_${monthYear}`;
//   const allMonths = allData.months || [];
  
//   // Create workbook
//   const wb = XLSX.utils.book_new();
  
//   // Create worksheet data
//   const wsData = [];
  
//   // Row 1: Month headers (spans 3 columns each)
//   const monthHeaderRow = ['S.N', 'Item', 'Supplier Name', 'Purchasing Unit'];
//   allMonths.forEach(month => {
//     monthHeaderRow.push(month.label, '', ''); // Month name, then 2 empty cells for merging
//   });
//   wsData.push(monthHeaderRow);
  
//   // Row 2: Sub-headers
//   const subHeaderRow = ['', '', '', ''];
//   allMonths.forEach(() => {
//     subHeaderRow.push('Latest Price', 'QTY', 'COST');
//   });
//   wsData.push(subHeaderRow);
  
//   // Data rows
//   allData.items.forEach((row, idx) => {
//     const dataRow = [
//       idx + 1, // S.N
//       row.name, // Item
//       row.supplier, // Supplier
//       row.unit // Unit
//     ];
    
//     // Add month data
//     allMonths.forEach(m => {
//       dataRow.push(
//         row[`${m.key}_latest_price`] || '',
//         row[`${m.key}_qty`] || '',
//         row[`${m.key}_cost`] || ''
//       );
//     });
    
//     wsData.push(dataRow);
//   });
  
//   // Create worksheet
//   const ws = XLSX.utils.aoa_to_sheet(wsData);
  
//   // Define colors matching your table (RGB values without #)
//   const monthColors = [
//     { header: '2196F3', light: 'E6F3FF' }, // Blue - JAN
//     { header: 'F44336', light: 'FFE6E6' }, // Red - FEB  
//     { header: '4CAF50', light: 'E6FFE6' }, // Green - MAR
//     { header: 'FF9800', light: 'FFF2E6' }, // Orange - APR
//     { header: '9C27B0', light: 'F3E6FF' }, // Purple - MAY
//     { header: '00BCD4', light: 'E6FFFF' }, // Cyan - JUN
//     { header: 'FFC107', light: 'FFF9E6' }, // Amber - JUL
//     { header: 'E91E63', light: 'FFE6F3' }, // Pink - AUG
//     { header: '8BC34A', light: 'E6FFE9' }, // Light Green - SEP
//     { header: '3F51B5', light: 'E6ECFF' }, // Indigo - OCT
//     { header: 'FF5252', light: 'FFE6EE' }, // Red Accent - NOV
//     { header: '009688', light: 'E6FFF9' }  // Teal - DEC
//   ];
  
//   // Calculate range
//   const totalCols = 4 + (allMonths.length * 3);
//   const totalRows = wsData.length;
//   const range = XLSX.utils.encode_range(
//     { c: 0, r: 0 }, 
//     { c: totalCols - 1, r: totalRows - 1 }
//   );
//   ws['!ref'] = range;
  
//   // Set up merges for month headers
//   const merges = [];
//   allMonths.forEach((month, index) => {
//     const startCol = 4 + (index * 3);
//     const endCol = startCol + 2;
//     merges.push({
//       s: { r: 0, c: startCol }, // start: row 0, column startCol
//       e: { r: 0, c: endCol }     // end: row 0, column endCol
//     });
//   });
//   ws['!merges'] = merges;
  
//   // Apply styles to all cells
//   const cellStyles = {};
  
//   for (let R = 0; R < totalRows; R++) {
//     for (let C = 0; C < totalCols; C++) {
//       const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
      
//       // Create cell if it doesn't exist
//       if (!ws[cellAddress]) {
//         ws[cellAddress] = { t: 's', v: '' };
//       }
      
//       // Base style for all cells
//       const baseStyle = {
//         border: {
//           top: { style: "thin" },
//           bottom: { style: "thin" },
//           left: { style: "thin" },
//           right: { style: "thin" }
//         }
//       };
      
//       // Header rows (Row 0 and 1)
//       if (R === 0 || R === 1) {
//         if (C < 4) {
//           // Base columns - dark header
//           cellStyles[cellAddress] = {
//             ...baseStyle,
//             fill: { 
//               patternType: "solid",
//               fgColor: { rgb: "424242" }
//             },
//             font: { 
//               bold: true, 
//               color: { rgb: "FFFFFF" },
//               sz: 11
//             },
//             alignment: { 
//               horizontal: "center", 
//               vertical: "center",
//               wrapText: true
//             }
//           };
//         } else {
//           // Month columns
//           const monthIndex = Math.floor((C - 4) / 3);
//           const colorSet = monthColors[monthIndex % monthColors.length];
          
//           cellStyles[cellAddress] = {
//             ...baseStyle,
//             fill: { 
//               patternType: "solid",
//               fgColor: { rgb: colorSet.header }
//             },
//             font: { 
//               bold: true, 
//               color: { rgb: "FFFFFF" },
//               sz: 11
//             },
//             alignment: { 
//               horizontal: "center", 
//               vertical: "center",
//               wrapText: true
//             }
//           };
//         }
//       } else {
//         // Data rows
//         if (C < 4) {
//           // Base columns - white background
//           cellStyles[cellAddress] = {
//             ...baseStyle,
//             fill: { 
//               patternType: "solid",
//               fgColor: { rgb: "FFFFFF" }
//             },
//             alignment: { 
//               horizontal: C === 0 ? "center" : "left",
//               vertical: "center"
//             },
//             font: { sz: 10 }
//           };
//         } else {
//           // Month columns - light colored background
//           const monthIndex = Math.floor((C - 4) / 3);
//           const colorSet = monthColors[monthIndex % monthColors.length];
          
//           cellStyles[cellAddress] = {
//             ...baseStyle,
//             fill: { 
//               patternType: "solid",
//               fgColor: { rgb: colorSet.light }
//             },
//             alignment: { 
//               horizontal: "right",
//               vertical: "center"
//             },
//             font: { sz: 10 }
//           };
          
//           // Add number format for numeric cells
//           if (ws[cellAddress].v && !isNaN(ws[cellAddress].v)) {
//             cellStyles[cellAddress].numFmt = "#,##0.00";
//           }
//         }
//       }
//     }
//   }
  
//   // Apply all styles at once
//   Object.keys(cellStyles).forEach(cellAddress => {
//     if (ws[cellAddress]) {
//       ws[cellAddress].s = cellStyles[cellAddress];
//     }
//   });
  
//   // Set column widths
//   const colWidths = [
//     { wch: 8 },   // S.N
//     { wch: 30 },  // Item
//     { wch: 25 },  // Supplier
//     { wch: 15 },  // Unit
//   ];
  
//   // Add widths for month columns
//   for (let i = 0; i < allMonths.length; i++) {
//     colWidths.push(
//       { wch: 15 }, // Latest Price
//       { wch: 10 }, // QTY
//       { wch: 15 }  // COST
//     );
//   }
  
//   ws['!cols'] = colWidths;
  
//   // Set row heights for headers to accommodate text
//   ws['!rows'] = [
//     { hpt: 30 }, // First header row height
//     { hpt: 25 }  // Second header row height
//   ];
  
//   // Add worksheet to workbook
//   XLSX.utils.book_append_sheet(wb, ws, 'Food Consumption Report');
  
//   // Write file with proper options
//   XLSX.writeFile(wb, `${fileName}.xlsx`, {
//     cellStyles: true,
//     bookSST: false,
//     type: 'binary'
//   });
// };

// Alternative: Export with BOM for better Excel compatibility
const handleDownload = () => {
  const fileName = `Supplier_Food_Consumption_Report_${monthYear}`;
  const allMonths = allData.months || [];
  
  // Helper function to escape CSV values
  const escapeCSV = (value) => {
    if (value === null || value === undefined) return '';
    const str = String(value);
    // If contains comma, quotes, or newlines, wrap in quotes and escape existing quotes
    if (str.includes(',') || str.includes('"') || str.includes('\n') || str.includes(';')) {
      return '"' + str.replace(/"/g, '""') + '"';
    }
    return str;
  };
  
  // Create CSV rows array
  const csvRows = [];
  
  // Row 1: Month headers
  const monthHeaderRow = ['S.N', 'Item','Formula','Supplier Name', 'Purchasing Unit'];
  allMonths.forEach(month => {
    monthHeaderRow.push(month.label);
    monthHeaderRow.push('');
    monthHeaderRow.push('');
  });
  csvRows.push(monthHeaderRow.map(escapeCSV).join(','));
  
  // Row 2: Sub-headers
  const subHeaderRow = ['', '', '', '', ''];
  allMonths.forEach(() => {
    subHeaderRow.push('Latest Price');
    subHeaderRow.push('QTY');
    subHeaderRow.push('COST');
  });
  csvRows.push(subHeaderRow.map(escapeCSV).join(','));
  
  // Data rows
  allData.items.forEach((row, idx) => {
    const dataRow = [
      row.sn,
      row.name,
      `${row.formula || (row.unit_levels ? exportFromula(row.unit_levels) : "")}`,
      row.supplier,
      row.unit
    ];
    
    allMonths.forEach(month => {
      dataRow.push(row[`${month.key}_latest_price`] || 0);
      dataRow.push(row[`${month.key}_qty`] || 0);
      dataRow.push(row[`${month.key}_cost`] || 0);
    });
    
    csvRows.push(dataRow.map(escapeCSV).join(','));
  });
  
  // Join all rows with newlines
  const csvContent = csvRows.join('\n');
  
  // Add BOM for better Excel compatibility
  const BOM = '\uFEFF';
  const csvWithBOM = BOM + csvContent;
  
  // Create and download CSV file
  const blob = new Blob([csvWithBOM], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  
  const link = document.createElement('a');
  link.href = url;
  link.download = `${fileName}.csv`;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  
  URL.revokeObjectURL(url);
};

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} - {to} of {size} records.
    </span>
  );
  const pagination_options = useMemo(() => ({
    page: tablePage,
    sizePerPage: pageSize,
    onPageChange: (page, sizePerPage) => {
      setTablePage(page);
      setPageSize(sizePerPage);
    },
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "200", value: 200 },
    ],
    hideSizePerPage: false,
    ignoreSinglePage: true,
  }), [tablePage, pageSize]);
  const pagination = useMemo(() => paginationFactory(pagination_options), [pagination_options]);
  const tableRows = allData.items || [];

const tableContainerStyles = {
  width: "100%",
  position: "relative",
};

const responsiveTableStyles = {
  marginTop: window.innerWidth >= 320 && window.innerWidth <= 992 ? "7px" : "0",
  minWidth: window.innerWidth >= 320 && window.innerWidth <= 992 ? "320px" : "auto",
  maxWidth: window.innerWidth >= 320 && window.innerWidth <= 992 ? "992px" : "none",
};

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb
            alternateTitle={props.t("Supplier Food Consumption Report")}
            title={props.t("Reports")}
            breadcrumbItem={props.t("Supplier Food Consumption Report")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                <AvForm>
                  <Row className="align-items-center">
                    <Col lg={3} sm={3}>
                      <input
                        type="month"
                        name="monthYear"
                        label={props.t("Month-Year")}
                        placeholder={props.t("Select Month")}
                        value={monthYear}
                        onChange={(e, v) => {
                          setMonthYear(e.target.value);
                        }}
                        max={currentMonthYear}
                        className="is-touched is-pristine av-valid form-control"
                      />
                    </Col>
                   
            <Col lg={3}>
                        <Button
                          type="button"
                          className="btn btn-md btn-success mt-1"
                          disabled={isLoading}
                          onClick={() => {
                            if (monthYear && monthYear) {
                              loadAllData();
                            }
                          }}
                        >
                          <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                          {props.t("Check")}
                        </Button>
            </Col>
            <Col lg={6}>
            <div className="d-flex justify-content-end align-items-center">
                      <Button
                        type="submit"
                           disabled={!allData.items || allData.items.length === 0}
                        className="btn btn-sm btn-secondary mr-2"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      {/* <Link
                        to="#"
                        disabled={!allData.items || allData.items.length === 0}
                        onClick={() => printDivForMainTable("Supplier Food Consumption Report")}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link> */}
                    </div>
            </Col>
          </Row>
        </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
           <Row >
            <Col className="col-12" >
              <Card>
                <CardBody>
                   <Col lg={12} className="text-center"> 
                                <CardTitle className="text-center">
                                  {("Supplier Food Consumption Report")}
                                </CardTitle>
                              </Col>
                  <div style={tableContainerStyles}>
                    <div 
                      id="Supplier Food Consumption Report" 
                      style={{
                        width: "100%",
                        height: "100vh",
                        overflowX: "auto",
                        // ...responsiveTableStyles
                      }}
                    >                   
                      <ToolkitProvider
                        keyField="_id"
                        data={tableRows}
                        columns={columns}
                        bootstrap4
                        search
                      >
                        {(tprops) => (
                          <div>
                            <Row>
                              <Col lg={4}>
                                <SearchBar
                                  {...tprops.searchProps}
                                  style={{ width: "300px" }}
                                />
                              </Col>
                             
                               <Col lg={4}></Col>
                            </Row>
                            <div style={{ width: "100%" }}>
                              <style jsx>{`
                                .table-container table {
                                  width: 100% !important;
                                }
                                .table-container table thead {
                                  position: sticky;
                                  top: 0;
                                }
                                
                              `}</style>
                              <div className="table-container">
                                <BootstrapTable
                                  striped
                                  hover
                                  condensed
                                  pagination={pagination}
                                  noDataIndication={
                                    isLoading ? (
                                      <Spinner size="md" />
                                    ) : (
                                      props.t("No data to display.")
                                    )
                                  }
                                  {...tprops.baseProps}
                                />
                              </div>
                            </div>
                          </div>
                        )}
                      </ToolkitProvider>
                  </div>
                  </div>

                </CardBody>
              </Card>
            </Col>
          </Row>

           <Modal
                      size="xl"
                      isOpen={isModalOpen}
                      toggle={() => setIsModalOpen(!isModalOpen)}
                    >
                      <ModalHeader toggle={() => setIsModalOpen(!isModalOpen)}>
                        {" "}
                        <Link
                          to="#"
                          onClick={() => {
                            printDiv("monthPurchaseDetails");
                          }}
                          className="btn btn-sm btn-success mr-2"
                        >
                          <i className="fa fa-print"></i> Print
                        </Link>
                      </ModalHeader>
                      <ModalBody>
                        <Row id="monthPurchaseDetails">
                          <Col lg={12}>
                           <Row>
  <Col lg={12}>
      {/* Title */}
    <CardTitle className="text-center">
      {props.t("Purchase Details")} for {monthData?.month_label}
    </CardTitle>
    {/* Item & Summary Details */}
   <div style={{ padding: "15px", borderRadius: "8px" }}>
  <div style={{ display: "flex", flexWrap: "wrap", marginBottom: "4px" }}>
    <div style={{ flex: "0 0 50%", maxWidth: "50%" }}>
      <strong>Supplier: </strong> {monthData?.item_info?.supplier_name}
    </div>
    <div style={{ flex: "0 0 50%", maxWidth: "50%", textAlign: "right" }}>
      <strong>Total Cost: </strong>
      {MonthlyTotalCost.toLocaleString("en-QA", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}
    </div>
    <div style={{ flex: "0 0 100%", maxWidth: "100%" }}>
      <strong>Item Name: </strong> {monthData?.item_info?.item_name}
    </div>
    <div style={{ flex: "0 0 100%", maxWidth: "100%" }}>
      <strong>Item S.N: </strong> {monthData?.deliveries?.[0]?.seq_no}
    </div>
  </div>
</div>
  </Col>
</Row>
                            <Card>
                              <CardBody>
                                <Row>
                                  <Col lg={12}>
                                   <ToolkitProvider
                bootstrap4
                keyField="po_id"
                data={monthData?.deliveries || []}
                columns={columnsPurchaseDetails}
                search
              >
                {(toolkitProps) => (
                  <div>
                    <BootstrapTable
                      striped
                      hover
                      filter={filterFactory({afterFilter})}
                      condensed
                      noDataIndication={
                        isLoadingDetails ? (
                          <Spinner size="md" />
                        ) : (
                          props.t("No data to display.")
                        )
                      }
                      {...toolkitProps.baseProps}
                    />
                  </div>
                )}
              </ToolkitProvider>
                                  
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      </ModalBody>
                    </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(FoodConsumptionReport))
);
